<template>
    <div id="EducationSection">
    <view1/>
    <view2/>

    </div>

</template>
<script>
    export default {
        name: 'EducationSection',
        components: {
            // 异步加载子组件
            view1: () => import('@/views/EducationSection/view1.vue'),
            view2: () => import('@/views/EducationSection/view2.vue')
        }
    }
</script>
<style scoped>

</style>